export default __webpack_public_path__ + "static/media/42_desktop.83dc1a03.jpg";